import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { i18n } from '../../translate/i18n'

const CompanyExpiredModal = ({ open, onClose, title, message }) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby='expired-dialog-title'>
      <DialogTitle id='expired-dialog-title'>{title || i18n.t('companyExpiredModal.title')}</DialogTitle>
      <DialogContent dividers>
        <Typography>{message || i18n.t('companyExpiredModal.message')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' color='primary' onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CompanyExpiredModal
